/**
 *    @author: Andrew Sheen
 *    @since:  2021-01-20
 *
 */

import { ViewportScroller } from '@angular/common';
import { Confirm } from 'src/refresh/service/constant';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../_common/component/IValidator';
import { Name, ParentInfo } from '../_common/data/input-data';
import { AboutTheParentsMainComponent} from './about_the_parents_main.component';

export class AboutTheParentsMainValidation extends IValidator {

       constructor(private component: AboutTheParentsMainComponent,
                   private viewportScroller: ViewportScroller, 
                   private menuID:number ) { 
                   super();
                   this.parentCount = this.component.data.eligibility.listedParentCount;
 
                   this.parentNames = new Array<Name>(this.parentCount);
                   this.isGiveBirth = new Array<string>(this.parentCount);

                   let inputParents = this.component.data.parents;
                   
                   for ( let i = 0; i < this.parentCount; i++ ) {
                         this.parentNames[i] = new Name();
                         this.parentNames[i].copyFrom(inputParents[i].name);
                         this.isGiveBirth[i] = inputParents[i].isGiveBirth;
                   }
                   
       }

       private parentNames:Name[];
       private isGiveBirth:string[];

       private parentCount:number;

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            for ( let i = 0; i < this.component.parentCount; i++ ) {

                  let  parentInfo:ParentInfo = this.component.parents[i];
                  if ( parentInfo.name.chk_singleName != 'Y' ) 
                       this.normalNameValidation(parentInfo,i);
                  else this.singleNameValidation(parentInfo,i);
            }

            if ( this.component.isSurrogate == false ) {
                 let hasGiveBirth = false;
                 for ( let i = 0; i < this.component.parentCount; i++ ) {
                       let  parentInfo:ParentInfo = this.component.parents[i];
                       if ( parentInfo.isGiveBirth == 'Y' ) { 
                            hasGiveBirth = true;
                            break;
                       }
                        
                       if ( parentInfo.isGiveBirth != 'N' ) {
                            this.focus("giveBirthDiv",'radio_giveBirth_'+i + "_0").errors[i].giveBirth = "aboutParent.giveBirth.error_empty";
                            break;
                       }
                  }

                  let cnt = this.component.parentCount-1;
                  if ( hasGiveBirth == false ) this.jump("giveBirth_"+cnt);
            }

            if ( this.component.isUnableToCertify  ) this.unableToCertifyValidation();

            return this.success;
       }

       private normalNameValidation(parentInfo:ParentInfo,i:number) {

             //---- [First Name] ---
             if ( Util.isEmpty(parentInfo.name.first) ) {
                   if ( !this.component.isCustodyOtherThanParent || parentInfo.isGiveBirth==Confirm.YES )
                   this.focus('name_'+i,'input_firstName' + i).errors[i].firstName = "aboutParent.firstName.error_empty$"; 
             }
             else
             if ( !Util.isValidName(parentInfo.name.first) ) 
                  this.focus('name_'+i,'input_firstName' + i).errors[i].firstName = "aboutParent.firstName.error_invalid$"; 


             //---- [Middle Name] ---
             if ( parentInfo.name.chk_middleNA == false  ) 
             {
                  if ( Util.isEmpty(parentInfo.name.middle) ) {
                      if ( !this.component.isCustodyOtherThanParent || parentInfo.isGiveBirth==Confirm.YES )
                      this.focus('name_'+i,'input_middleName' + i).errors[i].middleName = "aboutParent.middleName.error_empty$"; 
                  }
                  else
                  if ( !Util.isValidName(parentInfo.name.middle) ) 
                       this.focus('name_'+i,'input_middleName' + i).errors[i].middleName = "aboutParent.middleName.error_invalid$"; 
             }


             //---- [Last Name] ---
             if ( Util.isEmpty(parentInfo.name.last) ) 
                  this.focus('name_'+i,'input_lastName' + i).errors[i].lastName = "aboutParent.lastName.error_empty$"; 
             else
             if ( !Util.isValidName(parentInfo.name.last) ) 
                  this.focus('name_'+i,'input_lastName' + i).errors[i].lastName = "aboutParent.lastName.error_invalid$"; 
       }


       private singleNameValidation(parentInfo:ParentInfo,i:number) {

             if ( Util.isEmpty(parentInfo.name.single) ) 
                  this.focus('single_'+i,'input_singleName' + i).errors[i].singleName = "aboutParent.singleName.error_empty$"; 
             else
             if ( !Util.isValidName(parentInfo.name.single) ) 
                  this.focus('single_'+i,'input_singleName' + i).errors[i].singleName = "aboutParent.singleName.error_invalid$"; 
       }

       private unableToCertifyValidation() {

               let parents = this.component.parents;

               let certifyingcount = 0;
               let isReady:boolean = true;

               for ( let i = 0; i < this.component.parentCount; i++ ) {
                     if ( parents[i].name.completed() == false ) {
                          isReady = false;
                          break;
                     }
                     if ( parents[i].isCertifyingParent == 'Y' ) certifyingcount++;
               }

               if ( isReady == false ) return;

               if ( certifyingcount  == 0 ) {
                    if ( this.component.certyfyingCount == 1 ) 
                         this.focus('unableToCertify','radio_certify_0').error_parent2 = "aboutParent.certify.error_parent2_empty";
                    else
                         this.focus('unableToCertify','chkbox_cert_0').error_parent3 = "aboutParent.certify.error_parent3_empty";
                    this.success = false; 
               }
               else
               if ( certifyingcount != this.component.certyfyingCount ) {
                    this.focus('unableToCertify','chkbox_cert_0').error_parent3 = "aboutParent.certify.error_parentCountNotMatch";
                    this.success = false; 
               }
       }

       private jump(tagId:string) : AboutTheParentsMainComponent {
               if ( this.success )
                    this.viewportScroller.scrollToAnchor(tagId);
               this.success = false;
               return this.component;
       }

       private focus(tagId:string,ctrlId:string) : AboutTheParentsMainComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }

       public IdOfChanged():number { 

            for ( let i = 0; i < this.parentCount; i++ ) {
                  
                  let parentNames = this.parentNames[i];
                  let inputParent = this.component.data.parents[i];

                  if (  parentNames.first  !=  inputParent.name.first ||
                        parentNames.middle !=  inputParent.name.middle ||
                        parentNames.last   !=  inputParent.name.last ||
                        parentNames.single !=  inputParent.name.single ||
                        parentNames.chk_middleNA !=  inputParent.name.chk_middleNA ||
                        parentNames.chk_singleName !=  inputParent.name.chk_singleName ||  
                        this.isGiveBirth[i] !=  this.component.data.parents[i].isGiveBirth ) return this.menuID;
            }
            return 0;
       }

}
